import React from "react";
import styled from "styled-components";
import { color, flexCenter } from "../../style/theme";

const Pagination = ({ posts, totalPosts, paginate, currentPage }: any) => {
	const pageNumber = [];

	for (let i = 1; i <= Math.ceil(totalPosts / posts); i++) {
		pageNumber.push(i);
	}

	return (
		<PaginationSection>
			{pageNumber.map((pageNum) => (
				<PaginationItem
					key={pageNum}
					className="pagination_item"
					onClick={() => paginate(pageNum)}
					toggle={currentPage === pageNum}
				>
					{pageNum}
				</PaginationItem>
			))}
		</PaginationSection>
	);
};

interface IPaginationItem {
	toggle: boolean;
}

const PaginationSection = styled.ul`
	${flexCenter}

	width: 100%;
`;

const PaginationItem = styled.li<IPaginationItem>`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 2rem;
	height: 2rem;
	background: ${(props) => (props.toggle ? color.subPoint : "none")};
	border-radius: 50%;
	margin: 1rem;
	cursor: pointer;

	&:hover {
		text-decoration: underline 3px ${color.subPoint};
	}
`;

export default React.memo(Pagination);
